var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('h2',{staticClass:"ViewHeading"},[_vm._v("Devices and Routers")]),_c('div',[_c('b-row',[_c('b-col',[_c('h4',[_vm._v(_vm._s(this.selectedlocation))])])],1),_c('b-row')],1),_c('b-card',[_c('EndPoints')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }